import { CrewMember, Weld, WeldProcedure, RodDiameter, RodFillerMaterial } from '@bechtel/types';

export interface NewRodRequestProps {
  onClose: () => void;
  welds: Weld[];
}
export interface FillerMaterial {
  fillerMaterial: RodFillerMaterial;
  diameter: RodDiameter;
}

export interface RodRequestFormikState {
  welds: Weld[];
  weldProcedure: WeldProcedure;
  stencils: CrewMember[];
  fillerMaterials: FillerMaterial[];
  pickupLocation: string;
  pickupTime: string;
  comments: string;
}

export enum PickupTimeTerm {
  TODAY = 'TODAY',
  TOMORROW = 'TOMORROW',
  PAST_DAYS = 'PAST_DAYS',
}
